import { animated, useSpring } from '@react-spring/web';
import { useReducedMotion } from 'animations/useReducedMotion';
import React, { FC, useEffect } from 'react';

interface DashboardStatValueProps {
    value: number;
    format?: (n: number) => string;
    className?: string;
}

const DashboardStatValue: FC<DashboardStatValueProps> = ({
    value,
    format = (n) => Math.round(n).toLocaleString(),
    className = '',
}) => {
    const reducedMotion = useReducedMotion();
    const [spring, api] = useSpring(() => ({ val: 0 }));

    useEffect(() => {
        if (reducedMotion) {
            return;
        }
        api.start({ val: value, config: { tension: 120, friction: 20 } });
    }, [value, reducedMotion, api]);

    if (reducedMotion) {
        return <span className={className}>{format(value)}</span>;
    }

    return (
        <animated.span className={className}>
            {spring.val.to((n) => format(n))}
        </animated.span>
    );
};

export default DashboardStatValue;
